import { createSlice } from '@reduxjs/toolkit';

export const adminPortalSlice = createSlice({
    name: 'adminPortalSlice',
    initialState: {
        analysisData: "unloaded",
        userData: "unloaded",
        isAuthenticated: false,
        
    },
    reducers: {
        loadAnalysisData: (state, data) => { state.analysisData = data.payload },
        loaduserData: (state, data) => { state.userData = data.payload },
        setAuthentication: (state, data) => { state.isAuthenticated = data.payload },
        // setLanguageUrdu: (state) => {state.language = 'urdu'},
    }
});

export const { loadAnalysisData,loaduserData, setAuthentication } = adminPortalSlice.actions;

export const analysisData = (state) => { return (state.adminPortalSlice.analysisData) };
export const isAuthenticated = (state) => { return (state.adminPortalSlice.isAuthenticated) };
export const userData = (state) => { return (state.adminPortalSlice.userData) };

export default adminPortalSlice.reducer